import { useEffect, useRef } from 'react';
import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { Filters } from 'libs/form';

const initialFlt = {
  status: 'active',
};

const Filter = (props) => {
  const { locationState, reset, handleSubmit, change, type } = props;
  const formRef = useRef(null);

  const { t } = useTranslation();

  /**
   * set filter
   * @param {*} field
   * @param {*} value
   */
  const setFilter = (field, value) => {
    change(field, value);
  };

  /**
   * update filter
   * @param {*} filter
   */
  const updateFilter = (filter) => {
    reset();
    for (let field in filter) {
      setFilter(field, filter[field]);
    }

    setTimeout(() => {
      formRef.current.dispatchEvent(new Event('submit'));
    }, 500);
  };

  // did mount
  useEffect(() => {
    // console.log('🚀 ~ useEffect ~ locationState.filter:', locationState.filter);
    if (locationState && locationState.filter) {
      updateFilter(locationState.filter);
    }
  }, []);

  const filters = [
    {
      type: 'input',
      name: 'name',
      title: t('grid.Название'),
      placeholder: t('filter.Предприниматели'),
    },
    { type: 'dict', dict: 'tariff.type' },
    { type: 'dict', dict: 'tariff.status' },
    { type: 'doubledate', name: 'created_at', title: t('form.Дата создания'), change },
    { type: 'doubledate', name: 'time_from', title: t('form.Начало действия'), change },
    { type: 'categories', multiple: true },
    { type: 'classes', multiple: true },
    { type: 'parking' },
  ];

  return <Filters ref={formRef} items={filters} page={type} handleSubmit={handleSubmit} reset={reset} t={t} />;
};

export default reduxForm({
  form: 'tariffFilter',
  destroyOnUnmount: false,
  initialValues: initialFlt,
})(Filter);
